var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compute"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.54545 3V5.45455M14.4545 3V5.45455M9.54545 18.5455V21M14.4545 18.5455V21M18.5455 9.54545H21M18.5455 13.6364H21M3 9.54545H5.45455M3 13.6364H5.45455M7.09091 5.45455H16.9091C17.8128 5.45455 18.5455 6.18717 18.5455 7.09091V16.9091C18.5455 17.8128 17.8128 18.5455 16.9091 18.5455H7.09091C6.18717 18.5455 5.45455 17.8128 5.45455 16.9091V7.09091C5.45455 6.18717 6.18717 5.45455 7.09091 5.45455ZM9.54545 9.54545H14.4545V14.4545H9.54545V9.54545Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompute);
export default __webpack_public_path__ + "static/media/compute.7a5b9a37.svg";
export { ForwardRef as ReactComponent };